import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMessagesBubbleSquare = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "messages-bubble-square" }), /* @__PURE__ */ _jsx("path", { d: "M21.5,2H2.5A1.5,1.5,0,0,0,1,3.5v13A1.5,1.5,0,0,0,2.5,18H6.752a.25.25,0,0,1,.25.25V21.5a.5.5,0,0,0,.853.354l3.781-3.781A.253.253,0,0,1,11.813,18H21.5A1.5,1.5,0,0,0,23,16.5V3.5A1.5,1.5,0,0,0,21.5,2Z" })]
});
export default SvgMessagesBubbleSquare;
